import { useSession } from '@/contexts/LitSessionProvider';
import { useQueryClient } from '@tanstack/react-query';
import { updateDbCloudWallet } from '@/lib/db/DBCloudWalletHelpers';
import { useUserCloudQuery } from '../onboarding/useReferralQuery';
import useMultiTokenData from '../explore/useMultiTokenData';
export const useRecentToken = () => {
  const queryClient = useQueryClient();
  const {
    PKP
  } = useSession();
  const {
    data: recentTokenData
  } = useUserCloudQuery(PKP);
  const handleSaveRecent = async ({
    tokenData
  }: {
    tokenData: any;
  }) => {
    if (!tokenData) return;
    let saved = recentTokenData?.data?.recent_tokens ? [...recentTokenData?.data?.recent_tokens] : [];
    if (!saved.some(obj => obj?.token === tokenData.address && obj.network === tokenData?.networkId)) {
      const newToken = {
        token: tokenData?.address,
        network: tokenData?.networkId,
        name: tokenData?.token?.name
      };
      saved.push(newToken);
      saved = saved.filter((token, index, self) => index === self.findIndex(t => t.token === token.token && t.network === token.network));
      await updateDbCloudWallet({
        eth_address: PKP?.ethAddress,
        recent_tokens: JSON.stringify(saved)
      });
      queryClient.invalidateQueries({
        queryKey: ['cloudUserData']
      });
    }
  };
  const handleDeleteRecentToken = async (tokenToDelete: any) => {
    if (!recentTokenData?.data?.recent_tokens || !tokenToDelete) return;
    const saved = recentTokenData?.data?.recent_tokens.filter((token: any) => token.address !== tokenToDelete.address);
    await updateDbCloudWallet({
      eth_address: PKP?.ethAddress,
      recent_tokens: JSON.stringify(saved)
    });
    queryClient.invalidateQueries({
      queryKey: ['cloudUserData']
    });
  };
  const handleClearRecentTokens = async () => {
    if (!recentTokenData?.data?.recent_tokens) return;
    await updateDbCloudWallet({
      eth_address: PKP?.ethAddress,
      recent_tokens: JSON.stringify([])
    });
    queryClient.invalidateQueries({
      queryKey: ['cloudUserData']
    });
  };
  const {
    data: recentTokenDataWithPrices,
    isLoading: loading
  } = useMultiTokenData({
    tokens: recentTokenData?.data?.recent_tokens?.map(token => `${token.token}:${token.network}`)
  });
  return {
    handleSaveRecent,
    handleClearRecentTokens,
    handleDeleteRecentToken,
    recentTokenData: recentTokenDataWithPrices && recentTokenDataWithPrices?.length ? [...recentTokenDataWithPrices].reverse() : []
  };
};